var _circle, _path, _path2, _path3, _circle2, _path4, _circle3, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _circle4, _path25;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHomeHeader = function SvgHomeHeader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1139.17 654.54"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256.46,
    cy: 530.1,
    r: 59.24,
    fill: "var(--color-accent, lightgray)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-heading, lightslategray)",
    d: "M420.17 600.54h701v2h-701z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-stroke, darkgray)",
    d: "M683.8 18.65H423.61V13.3H305.65v5.36H44.41a17.6 17.6 0 0 0-17.6 17.6V392.5a17.6 17.6 0 0 0 17.6 17.6h639.38a17.6 17.6 0 0 0 17.6-17.6V36.25a17.6 17.6 0 0 0-17.6-17.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-background, black)",
    d: "M50.41 49.75H677.8v353.91H50.41z",
    opacity: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 363.57,
    cy: 33.67,
    r: 6.43,
    fill: "var(--color-background, black)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-background, black)",
    d: "M498.37 403.67H50.41V49.75l447.96 353.92z",
    opacity: 0.25
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.57,
    cy: 316.88,
    r: 60.31,
    fill: "var(--color-accent, lightgray)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-accent, lightgray)",
    d: "M509.95 240.62h58.61v12.25h-58.61z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-text-light, gray)",
    d: "M439.1 145.28h200.31v5.25H439.1zM439.1 161.9h200.31v5.25H439.1zM439.1 178.52h200.31v5.25H439.1zM439.1 195.14h200.31v5.25H439.1zM439.1 211.76h200.31v5.25H439.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-accent, lightgrey)",
    d: "M614.92 56.93h24.49v24.49h-24.49z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-fill, lightgray)",
    d: "M650.78 92.8h-29.74V63.06h29.74Zm-28.45-1.3h27.16V64.35h-27.16Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-stroke, darkgray)",
    d: "M719 397.23h-61.22v-4.41a.87.87 0 0 0-.88-.87h-20.99a.87.87 0 0 0-.87.87v4.41H621.9v-4.41a.87.87 0 0 0-.87-.87h-21a.87.87 0 0 0-.87.87v4.41h-13.12v-4.41a.87.87 0 0 0-.87-.87h-21a.87.87 0 0 0-.87.87v4.41h-13.12v-4.41a.87.87 0 0 0-.88-.87h-20.99a.87.87 0 0 0-.87.87v4.41h-13.12v-4.41a.87.87 0 0 0-.88-.87h-21a.87.87 0 0 0-.87.87v4.41h-13.12v-4.41a.87.87 0 0 0-.87-.87h-21a.87.87 0 0 0-.87.87v4.41H442.6v-4.41a.87.87 0 0 0-.87-.87H277.28a.87.87 0 0 0-.87.87v4.41h-13.12v-4.41a.87.87 0 0 0-.88-.87h-21a.87.87 0 0 0-.87.87v4.41h-13.12v-4.41a.87.87 0 0 0-.87-.87h-21a.87.87 0 0 0-.87.87v4.41h-13.12v-4.41a.87.87 0 0 0-.87-.87h-21a.87.87 0 0 0-.87.87v4.41H155.7v-4.41a.87.87 0 0 0-.88-.87h-20.99a.87.87 0 0 0-.87.87v4.41h-13.13v-4.41a.87.87 0 0 0-.87-.87h-21a.87.87 0 0 0-.87.87v4.41H83.97v-4.41a.87.87 0 0 0-.87-.87h-21a.87.87 0 0 0-.87.87v4.41H20.99a21 21 0 0 0-20.99 21v9.49a21 21 0 0 0 21 20.99h698a21 21 0 0 0 21-21v-9.49a21 21 0 0 0-21-20.99Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-fill, gray)",
    d: "M163.17 354.54a76 76 0 1 1 76-76 76.09 76.09 0 0 1-76 76Zm0-150a74 74 0 1 0 74 74 74.08 74.08 0 0 0-74-74Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-heading, lightslategray)",
    d: "M586.17 5h255v2h-255zM406.17 625.54h733v2h-733z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-accent, lightgray)",
    d: "M192.67 652.54h255v2h-255zM471 550h28v28h-28z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-fill, lightgray)",
    d: "M516 562h-34v-34h34Zm-32.52-1.48h31.04v-31.04h-31.04Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-accent, lightgray)",
    d: "M796 22h28v28h-28z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-fill, lightgray)",
    d: "M841 66h-34V32h34Zm-32.52-1.48h31.04V33.48h-31.04Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-accent, lightgray)",
    d: "M1078 550h28v28h-28z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-fill, lightgray)",
    d: "M1123 562h-34v-34h34Zm-32.52-1.48h31.04v-31.04h-31.04Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-stroke, darkgray)",
    d: "M1057.17 231.96h-2.38V166.8a37.71 37.71 0 0 0-37.71-37.72H879.03a37.71 37.71 0 0 0-37.72 37.72v357.48a37.71 37.71 0 0 0 37.72 37.71h138.05a37.71 37.71 0 0 0 37.71-37.71V278.34h2.38Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-background, black)",
    d: "M1046.76 169.01v356.96a28.17 28.17 0 0 1-28.16 28.17H879.88a28.17 28.17 0 0 1-28.16-28.17V169.01a28.16 28.16 0 0 1 28.16-28.16h16.83a13.38 13.38 0 0 0 12.4 18.43h79.08a13.38 13.38 0 0 0 12.4-18.43h18.01a28.16 28.16 0 0 1 28.16 28.16Z",
    opacity: 0.5
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-accent, lightgray)",
    d: "M928.58 376.22h41.32v12.25h-41.32z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-text-light, gray)",
    d: "M878.62 280.87h141.24v5.25H878.62zM878.62 297.49h141.24v5.25H878.62zM878.62 314.11h141.24v5.25H878.62zM878.62 330.73h141.24v5.25H878.62zM878.62 347.35h141.24v5.25H878.62z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-accent, lightgray)",
    d: "M929.68 211.18h24.49v24.49h-24.49z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-fill, lightgray)",
    d: "M939.06 217.3v29.74h29.74V217.3Zm28.45 28.45h-27.16V218.6h27.16Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1046.76 487.85v38.12a28.17 28.17 0 0 1-28.16 28.17H879.88a28.17 28.17 0 0 1-28.16-28.17v-192.2l116.87 92.32 2 1.58 21.74 17.17 2.03 1.61Z",
    opacity: 0.1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 937.24,
    cy: 498.71,
    r: 43.87,
    fill: "var(--color-accent, lightgray)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-fill, gray)",
    d: "M320.17 654.54a87 87 0 1 1 87-87 87.1 87.1 0 0 1-87 87Zm0-172a85 85 0 1 0 85 85 85.1 85.1 0 0 0-85-85ZM950.17 532.54a55 55 0 1 1 55-55 55.06 55.06 0 0 1-55 55Zm0-108a53 53 0 1 0 53 53 53.06 53.06 0 0 0-53-53Z"
  })));
};
export default SvgHomeHeader;